module.exports = __webpack_public_path__ + "static/media/unisocks1.d4abeabc.png";